import { apiSlice } from '../../api/apiSlice';

export const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: 'Account/Authenticate',
        method: 'POST',
        credentials: 'include',
        body: { ...credentials }
      })
    }),
    logout: builder.mutation({
      query: () => ({
        url: 'Account/Logout',
        method: 'POST',
        credentials: 'include'
      })
    }),
    getClassicLoginPage: builder.mutation({
      query: () => ({
        url: 'Account/GetClassicLoginPage',
        method: 'GET',
        responseHandler: 'text'
      })
    }),
    refresh: builder.mutation({
      query: () => ({
        url: 'Account/RefreshToken',
        method: 'POST',
        credentials: 'include'
      })
    }),
    classicLogin: builder.mutation({
      query: (credentials) => ({
        url: 'Account/ClassicCastleAuthenticate',
        method: 'POST',
        body: { ...credentials },
        credentials: 'include'
      })
    }),
    forgotPassword: builder.mutation({
      query: (accountEmail) => ({
        url: 'Account/ForgotPassword/' + accountEmail,
        method: 'POST'
      })
    }),
    saveAssignmentLinkNote: builder.mutation({
      query: (options) => ({
        url: `Assignment/SaveAssignmentLinkNote?note=${options.note}&urlGuid=${options.urlGuid}`,
        method: 'POST'
      })
    }),
    getForgotPasswordUser: builder.query({
      query: (resetToken) => ({
        url: 'Account/GetForgotPasswordUser/' + resetToken,
        method: 'GET'
      })
    }),
    updateUserPassword: builder.mutation({
      query: (newPasswordDetails) => ({
        url: 'Account/UpdateUserPassword',
        method: 'POST',
        body: { ...newPasswordDetails }
      })
    }),
    getNews: builder.mutation({
      query: () => ({
        url: 'Dashboard/GetNews',
        method: 'GET',
        credentials: 'include'
      })
    }),
    getMessageCount: builder.mutation({
      query: () => ({
        url: 'Alert/GetAlertCount',
        method: 'GET',
        credentials: 'include'
      })
    }),
    getAllAlerts: builder.mutation({
      query: (options) => ({
        url: `Alert/AllAlerts/${options.skip}/${options.take}`,
        params: {
          viewType: options.viewType,
          orderBy: options.orderBy,
          searchText: options.searchText
        },
        method: 'GET',
        credentials: 'include'
      })
    }),
    getAvailableSchoolYears: builder.mutation({
      query: () => ({
        url: 'SchoolYear/GetAvailableSchoolYears',
        method: 'GET',
        credentials: 'include'
      })
    }),
    getAllStates: builder.mutation({
      query: () => ({
        url: 'State/GetAllStates',
        method: 'GET',
        credentials: 'include'
      })
    }),
    getAllSchools: builder.mutation({
      query: () => ({
        url: 'School/GetAllSchools',
        method: 'GET',
        credentials: 'include'
      })
    }),
    generateOneTimeCode: builder.mutation({
      query: () => ({
        url: 'School/GenerateOneTimeCode',
        method: 'GET',
        credentials: 'include'
      })
    }),
    updateAdditonalOptionsComment: builder.mutation({
      query: (options) => {
        const comment = options.comment;
        return {
          url: `School/${options.schoolId}/UpdateComment?comment=${comment}`,
          method: 'PUT',
          credentials: 'include'
        };
      }
    }),
    updateSchoolYear: builder.mutation({
      query: (year) => ({
        url: 'SchoolYear/YearChange?year=' + year,
        method: 'PUT',
        credentials: 'include'
      })
    }),
    getschoolInfo: builder.mutation({
      query: (schoolId) => ({
        url: `School/${schoolId}/Info`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    updateState: builder.mutation({
      query: (stateId) => ({
        url: 'State/UpdateStateChange?stateId=' + stateId,
        method: 'PUT',
        credentials: 'include'
      })
    }),
    getStudents: builder.mutation({
      query: () => ({
        url: 'Student/GetAllUsers',
        params: { searchString: '' },
        method: 'GET',
        credentials: 'include'
      })
    }),
    getAllCourseList: builder.mutation({
      query: () => ({
        url: 'Course/GetAllCourseList',
        method: 'GET',
        credentials: 'include'
      })
    }),
    getDBQCourses: builder.mutation({
      query: () => ({
        url: 'Course/DBQCourses',
        method: 'GET',
        credentials: 'include'
      })
    }),
    getAllCustomCourses: builder.mutation({
      query: () => ({
        url: 'Course/custom',
        method: 'GET',
      })
    }),
    getAssignmentFolders: builder.mutation({
      query: () => ({
        url: 'Assignment/GetAssignmentFolders',
        method: 'GET',
        credentials: 'include'
      })
    }),
    getAllAssignmentStatus: builder.mutation({
      query: () => ({
        url: 'Assignment/GetAllAssignmentStatus',
        method: 'GET',
        credentials: 'include'
      })
    }),
    getAllAssignedVia: builder.mutation({
      query: () => ({
        url: 'Assignment/GetAllAssignedVia',
        method: 'GET',
        credentials: 'include'
      })
    }),
    getAssignmentsByFilter: builder.mutation({
      query: (options) => {
        const { assignmentStatus, courseId, folderId, assignedVia } = options;
        let url = `Assignment/GetAssignmentsByFilter/${options.skip}/${options.take}?`;
        if (courseId) url += `CourseId=${courseId}&`;
        if (folderId) url += `FolderId=${folderId}&`;
        if (assignmentStatus && assignmentStatus.length > 0) {
          assignmentStatus.forEach((assignmentId, index) => {
            url += `AssignmentStatus=${assignmentId}${assignmentStatus.length !== index ? '&' : ''
            }`;
          }); 
        }
        if (assignedVia && assignedVia.length > 0) {
          assignedVia.forEach((assignedViaId, index) => {
            url += `AssignedVia=${assignedViaId}${assignedVia.length !== index + 1 ? '&' : ''}`;
          });
        }
        return {
          url: url,
          method: 'GET',
          params: {
            SearchText: options.searchText,
            sort: options.sort,
            IsSearch: options.isSearch
          },
          credentials: 'include'
        };
      }
    }),
    getPublicAssignments: builder.mutation({
      query: (options) => ({
        url: `Assignment/GetPublicAssignments/${options.skip}/${options.take}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getPublicAssignmentProperties: builder.mutation({
      query: (options) => ({
        url: `Assignment/${options.assignmentId}/properties`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getPublicSet: builder.mutation({
      query: (options) => ({
        url: `Assignment/${options.assignmentId}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    deletePublicAssignment: builder.mutation({
      query: (options) => ({
        url: `Assignment/${options.assignmentId}`,
        method: 'DELETE',
        credentials: 'include'
      })
    }),
    maintenanceNotification: builder.mutation({
      query: (currentCenter) => ({
        url: `Dashboard/GetSystemNotifications?currentCenter=${currentCenter}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    updateEmailId: builder.mutation({
      query: (options) => ({
        url: `Student/UpdateMailId?email=${options.email}&password=${options.password}`,
        method: 'PUT',
        credentials: 'include'
      })
    }),
    getClasses: builder.mutation({
      query: () => ({
        url: 'Class/GetClasses',
        method: 'GET',
        credentials: 'include'
      })
    }),
    getStudentsDetailsByClasses: builder.mutation({
      query: (options) => {
        return {
          url: `Student/NotAssignedByClassIds/${options.skip}/${options.take}`,
          method: 'POST',
          body: {
            assignmentIds: options.aIds,
            classIds: options.classIds
          }
        };
      }
    }),
    getAssignmentLinks: builder.query({
      query: () => ({
        url: 'Assignment/GetAssignmentLinks',
        method: 'GET'
      })
    }),
    deleteAssignmentLinks: builder.mutation({
      query: (urlGuid) => ({
        url: `Assignment/DeleteAssignmentLink/${urlGuid}`,
        method: 'DELETE'
      })
    }),
    getGoogleClassroomClasses: builder.query({
      query: () => ({
        url: '/Class/GetGoogleClassroomClasses',
        method: 'GET'
      })
    }),
    processToken: builder.mutation({
      query: (options) => ({
        url: `/Class/ProcessToken?url=${options.url}`,
        method: 'GET'
      })
    }),
    navigateToClassicCastle: builder.mutation({
      query: (navRequest) => ({
        url: '/Account/NavigateToClassicCastle',
        method: 'POST',
        body: { ...navRequest },
        credentials: 'include'
      })
    }),
    getClassId: builder.mutation({
      query: () => ({
        url: 'Class/ClassId',
        method: 'GET',
        credentials: 'include'
      })
    }),
    addClassId: builder.mutation({
      query: (options) => ({
        url: `Class/ClassId/${options.classId}`,
        method: 'PUT',
        credentials: 'include'
      })
    }),
    getFilters: builder.mutation({
      query: () => ({
        url: 'Assignment/GetFilters',
        method: 'GET',
        credentials: 'include'
      })
    }),
    getEmail: builder.mutation({
      query: () => ({
        url: 'Student/GetEmail',
        method: 'GET',
        credentials: 'include'
      })
    }),
    getSystemVersion: builder.mutation({
      query: () => ({
        url: 'System/GetVersionInfo',
        method: 'GET',
        responseHandler: 'text'
      })
    }),
    loginWithGoogle: builder.mutation({
      query: (credentials) => ({
        url: 'Account/LoginWithGoogle',
        method: 'POST',
        credentials: 'include',
        body: { ...credentials }
      })
    }),
    loginWithGoogleOneTap: builder.mutation({
      query: (credentials) => ({
        url: 'Account/LoginWithGoogleOneTap',
        method: 'POST',
        credentials: 'include',
        headers: {'Content-Type': 'application/json'},
        body: { ...credentials }
      })
    }),
    authenticateSuperAdmin: builder.mutation({
      query: (credentials) => ({
        url: 'Account/AuthenticateSuperAdmin',
        method: 'POST',
        credentials: 'include',
        body: { ...credentials }
      })
    }),
    validateSSO: builder.mutation({
      query: ({ TimeZoneOffset } = {}) => ({
        url: 'SSO/NycSSO',
        params: { TimeZoneOffset },
        method: 'GET',
        credentials: 'include'
      })
    }),
    InitiateSiteSwitchLog: builder.mutation({
      query: () => ({
        url: 'Account/InitiateSiteSwitchLog',
        method: 'POST',
        credentials: 'include'
      })
    }),
    schoologySSO: builder.mutation({
      query: (option) => ({
        url: `SSO/SchoologySSO?email=${option.email}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    canvasSSO: builder.mutation({
      query: (option) => ({
        url: `SSO/canvasSSO?email=${option.email}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    resetDefaultPassword: builder.mutation({
      query: (options) => ({
        url: 'Account/ResetDefaultPassword',
        method: 'POST',
        body: {...options},
        credentials: 'include'
      })
    }),
    sendPodioFeedback: builder.mutation({
      query: (feedback) => ({
        url: 'Dashboard/SendPodioFeedback',
        method: 'POST',
        body: { ...feedback }
      })
    }),
    updateViewStatusBulk: builder.mutation({
      query: () => ({
        url: 'Alert/MarkAllAsRead',
        method: 'PUT'
      })
    }),
    getRecentAlerts: builder.mutation({
      query: () => ({
        url: 'Alert/Recent',
        method: 'GET'
      })
    })
  })
});

export const {
  useSaveAssignmentLinkNoteMutation,
  useLoginMutation,
  useLogoutMutation,
  useClassicLoginMutation,
  useRefreshMutation,
  useForgotPasswordMutation,
  useGetForgotPasswordUserQuery,
  useUpdateUserPasswordMutation,
  useGetNewsMutation,
  useGetMessageCountMutation,
  useGetAllAlertsMutation,
  useGetAvailableSchoolYearsMutation,
  useGetAllStatesMutation,
  useGetAllSchoolsMutation,
  useGenerateOneTimeCodeMutation,
  useUpdateAdditonalOptionsCommentMutation,
  useUpdateSchoolYearMutation,
  useGetAllCourseListMutation,
  useGetDBQCoursesMutation,
  useGetAllCustomCoursesMutation,
  useGetAssignmentFoldersMutation,
  useGetAllAssignmentStatusMutation,
  useGetAllAssignedViaMutation,
  useGetAssignmentsByFilterMutation,
  useGetschoolInfoMutation,
  useUpdateStateMutation,
  useGetStudentsMutation,
  useGetPublicAssignmentsMutation,
  useGetPublicAssignmentPropertiesMutation,
  useGetPublicSetMutation,
  useDeletePublicAssignmentMutation,
  useMaintenanceNotificationMutation,
  useUpdateEmailIdMutation,
  useGetClassesMutation,
  useGetStudentsDetailsByClassesMutation,
  useLazyGetAssignmentLinksQuery,
  useDeleteAssignmentLinksMutation,
  useLazyGetGoogleClassroomClassesQuery,
  useNavigateToClassicCastleMutation,
  useGetClassIdMutation,
  useAddClassIdMutation,
  useGetFiltersMutation,
  useGetClassicLoginPageMutation,
  useGetEmailMutation,
  useGetSystemVersionMutation,
  useLoginWithGoogleMutation,
  useAuthenticateSuperAdminMutation,
  useValidateSSOMutation,
  useProcessTokenMutation,
  useInitiateSiteSwitchLogMutation,
  useLoginWithGoogleOneTapMutation,
  useSchoologySSOMutation,
  useResetDefaultPasswordMutation,
  useCanvasSSOMutation,
  useSendPodioFeedbackMutation,
  useUpdateViewStatusBulkMutation,
  useGetRecentAlertsMutation
} = authApi;
